<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'random',
  },
  birdClass: {
    type: String,
    default: 'h-auto'
  },
});

const skins = [
    'cowboy',
    'wizard',
    'warrior',
    'postman',
    'cook',
    'fitness',
    'reader',
    'firefighter'
];

const showSkin = () => {
    if (props.type === 'random') {
        return skins[Math.floor((Math.random()*skins.length))];
    } else return props.type
};

const pickedSkin = showSkin()
</script>

<template>
  <svg
    :class="birdClass"
    width="268"
    height="278"
    viewBox="0 0 268 278"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M99.792 257.242V220.872C99.792 220.456 100.117 220.118 100.517 220.118H106.954C107.385 220.118 107.722 220.501 107.676 220.947C107.154 225.987 104.29 252.461 101.136 257.643C100.744 258.286 99.792 258.003 99.792 257.242L99.792 257.242Z"
      fill="#693118"
    />
    <path
      d="M128 255.5L123.222 219.224C123.163 218.79 122.8 218.487 122.412 218.548L116.174 219.53C115.756 219.596 115.484 220.047 115.592 220.506C116.813 225.686 123.168 251.717 126.96 256.644C127.431 257.255 128.108 256.294 128 255.5Z"
      fill="#693118"
    />
    <path
      d="M203.717 97.3337L227.978 98.7324L212.022 103.45L227.959 111.527L203.689 116.525L203.717 97.3337Z"
      fill="#DB8827"
    />
    <path
      d="M24.0859 114.027C24.0859 114.027 17.4726 237.289 120.318 222.75C147.343 218.929 164.538 207.085 172.852 199.362C181.165 191.64 208.237 155.378 208.781 112.788C209.326 70.1989 196.26 61.6908 179.89 59.0305C163.52 56.3703 150.669 75.453 148.904 84.2393C147.138 93.0256 142.805 138.354 112.759 143.222C70.3047 150.101 24.0859 114.027 24.0859 114.027Z"
      fill="#FAA723"
    />
    <path
      d="M168.804 98.4746C168.977 99.5379 169.493 102.728 173.11 105.415C176.727 108.103 180.861 107.433 181.895 107.265C182.928 107.098 188.613 102.903 188.097 99.7132C187.581 96.5234 187.926 92.1028 182.242 89.7503C176.558 87.3978 173.801 90.0268 171.906 91.425C170.011 92.8232 168.46 96.348 168.804 98.4746Z"
      fill="white"
    />
    <path
      d="M180.177 102.58C177.556 103.004 175.088 101.223 174.664 98.6013C174.239 95.9795 176.02 93.5099 178.64 93.0852C181.261 92.6606 183.729 94.4418 184.154 97.0636C184.578 99.6854 182.798 102.155 180.177 102.58Z"
      fill="black"
    />
    <path
      v-if="pickedSkin === 'reader'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M178.504 115.025C188.171 115.025 196.007 107.184 196.007 97.5125C196.007 97.341 196.005 97.1702 196 97H207C208.105 97 209 96.1046 209 95C209 93.8954 208.105 93 207 93H195.421C193.431 85.515 186.611 80 178.504 80C169.346 80 161.831 87.0363 161.064 96L149.702 96.0001C149.112 96.0001 148.552 96.261 148.172 96.7128L142.287 103.71C141.576 104.555 141.685 105.817 142.531 106.528C143.376 107.239 144.638 107.13 145.349 106.284L150.334 100.356C150.524 100.13 150.804 100 151.099 100H161.175C162.382 108.494 169.681 115.025 178.504 115.025ZM178.353 111.704C186.27 111.704 192.688 105.282 192.688 97.3615C192.688 89.4406 186.27 83.0194 178.353 83.0194C170.436 83.0194 164.018 89.4406 164.018 97.3615C164.018 105.282 170.436 111.704 178.353 111.704Z"
      fill="#999999"
    />
    <ellipse
      v-if="pickedSkin === 'reader'"
      cx="178.352"
      cy="97.3614"
      rx="14.3348"
      ry="14.3421"
      fill="#236439"
      fill-opacity="0.23"
    />
    <path
      v-if="pickedSkin === 'reader'"
      d="M171.261 87.6993C174.731 84.2272 185.462 85.6193 186.048 89.6618C186.158 90.4166 184.298 90.8695 183.634 90.1146C180.314 86.3406 177.209 85.592 171.261 87.6993Z"
      fill="#CCDBD1"
    />
    <ellipse
      v-if="pickedSkin === 'reader'"
      cx="1.35836"
      cy="1.66071"
      rx="1.35836"
      ry="1.66071"
      transform="matrix(0.911277 -0.411794 0.411448 0.911433 186.652 92.5923)"
      fill="#CCDBD1"
    />
    <path
      v-if="pickedSkin === 'reader'"
      d="M185.812 143.978L207.002 150.988C208.534 151.495 209.987 152.253 210.691 153.719C211.384 155.166 211.081 156.752 210.613 158.168L201.651 185.259C201.238 186.505 200.667 187.676 199.701 188.457C199.144 188.907 198.475 189.199 197.766 189.302L197.076 191.386C196.571 192.915 195.814 194.369 194.351 195.075C192.903 195.772 191.318 195.467 189.901 194.998L165.446 186.908C164.533 186.606 163.777 185.953 163.345 185.094C162.913 184.234 162.839 183.238 163.142 182.325L173.952 149.649C174.323 148.503 174.788 147.073 175.531 145.875C176.44 144.413 177.834 143.165 180.031 142.829C180.937 142.691 181.806 142.806 182.701 143.025C183.562 143.234 184.584 143.572 185.812 143.978ZM166.585 183.464L191.04 191.555C192.296 191.97 192.681 191.853 192.775 191.808C192.851 191.771 193.2 191.553 193.633 190.247L194.126 188.755L171.168 181.16C170.255 180.858 169.259 180.931 168.4 181.363C167.54 181.795 166.887 182.551 166.585 183.464Z"
      fill="#4F2B1B"
    />
    <path
      v-if="pickedSkin === 'reader'"
      d="M166.585 183.464L191.04 191.555C192.296 191.97 192.681 191.853 192.775 191.808C192.851 191.771 193.2 191.553 193.633 190.247L194.126 188.755L171.168 181.16C170.255 180.858 169.259 180.931 168.4 181.363C167.54 181.795 166.887 182.551 166.585 183.464Z"
      fill="white"
    />
    <path
      v-if="pickedSkin === 'cowboy'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M194.29 48.8597L187.078 28.1149C186.689 26.9889 186.076 25.9533 185.276 25.0701C184.476 24.1869 183.506 23.4744 182.424 22.9753C181.342 22.4762 180.171 22.2008 178.98 22.1656C177.789 22.1304 176.603 22.3361 175.494 22.7704L150.337 32.6066C148.6 33.2858 147.121 34.497 146.113 36.067C145.106 37.637 144.62 39.4855 144.726 41.3481L145.253 50.3966L145.4 54.8873C136.637 58.0028 130.612 67.2377 130.048 78.9706C129.937 81.3144 130.751 83.5941 132.281 85.2287C133.769 86.8198 135.723 87.5525 137.639 87.2364L212.12 74.95C213.368 74.6832 214.124 73.34 214.5 70.9999C214.661 69.9999 215.14 69.0214 215.713 67.9048C216.738 66.4746 217.153 64.6957 216.866 62.9595C216.295 59.4968 210.145 47.351 194.29 48.8597ZM212.12 74.95C211.332 75.0661 210.586 75.1741 209.873 75.2746C210.605 75.1845 211.353 75.0765 212.12 74.95Z"
      fill="#9E7E60"
    />
    <path
      v-if="pickedSkin === 'cowboy'"
      d="M162.699 56.6332C158.279 54.1487 153.455 53.2464 148.763 54.0204C138.207 55.7617 130.681 65.7898 130.048 78.9706C129.937 81.3144 130.751 83.5941 132.281 85.2287C133.769 86.8198 135.723 87.5525 137.639 87.2364L212.12 74.95C198.044 77.272 190.147 73.3814 177.967 65.9497L162.699 56.6332ZM194.29 48.8597L187.078 28.1149C186.689 26.9889 186.076 25.9533 185.276 25.0701C184.476 24.1869 183.506 23.4744 182.424 22.9753C181.342 22.4762 180.171 22.2008 178.98 22.1656C177.789 22.1304 176.603 22.3361 175.494 22.7704L150.337 32.6066C148.6 33.2858 147.121 34.497 146.113 36.067C145.106 37.637 144.62 39.4855 144.726 41.3481L145.253 50.3966C146.175 50.1282 147.077 49.8156 148.043 49.6561C153.743 48.716 159.554 49.7957 165.003 52.8573L180.269 62.1741C191.34 68.9272 198.157 72.7703 211.4 70.5858C213.136 70.2994 214.687 69.335 215.713 67.9048C216.738 66.4746 217.153 64.6957 216.866 62.9595C216.295 59.4968 210.145 47.351 194.29 48.8597Z"
      fill="#4F2B1B"
    />
    <path
      v-if="pickedSkin === 'cowboy'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M102.918 231.098C102.959 231.098 103 231.098 103.041 231.098C103.112 231.099 103.186 231.101 103.259 231.104L103.263 231.104L103.282 231.105L104.434 231.191C105.751 231.344 106.844 231.679 107.675 232.325C108.72 233.139 109.445 234.476 109.692 236.86L109.863 238.521L110.744 237.104C111.071 236.577 111.674 236.266 112.269 236.083C111.925 237.655 111.564 239.222 111.185 240.785L110.888 242C110.231 244.65 108.04 247.211 107.298 249.745L107.21 250.045L110.693 254.086L111.675 254.84C114.579 255.252 118.463 255.989 121 259.344C118.947 259.66 115.934 259.632 112.845 259.602C111.377 259.588 109.891 259.574 108.484 259.597L107.185 258.899C105.999 258.026 104.794 257.299 103.549 256.882L102.358 257.801C101.908 258.492 101.626 259.231 101.461 259.944C100.677 260.002 99.8045 260.043 99.1079 259.919C98.1952 259.052 97.5837 258.207 97.2431 257.284L97.1537 256.124C97.2276 255.862 97.3033 255.572 97.3833 255.266C97.7031 254.043 98.0909 252.559 98.6994 251.566L98.6934 251.545L98.6929 251.569C97.5501 251.379 96.714 251.183 95.6302 250.834L95.6199 250.859L95.6168 250.866L96.4138 252.468L94.8195 251.667L94.7922 251.679L94.7708 251.688L94.7349 251.703L94.1713 253.401L93.6079 251.703C93.5793 251.692 93.551 251.68 93.5231 251.667L91.9288 252.468L92.726 250.866C92.7197 250.852 92.7136 250.838 92.7076 250.824C92.7017 250.809 92.696 250.795 92.6905 250.781L91 250.215L92.6905 249.649C92.7016 249.62 92.7134 249.591 92.7261 249.563L91.9288 247.962L93.5232 248.762C93.5393 248.755 93.5555 248.748 93.572 248.741L93.6079 248.727L94.1713 247.028L94.7348 248.727C94.7633 248.738 94.7915 248.75 94.8194 248.762L96.4138 247.962L95.6168 249.563L95.6286 249.59L95.6397 249.617L95.6522 249.649L96.0756 249.78C96.3083 249.84 96.5364 249.903 96.7623 249.965C97.4589 250.157 98.1357 250.344 98.8689 250.43L98.8673 250.446L98.8775 250.427C98.1083 246.746 98.8638 243.182 98.4137 239.521L98.2819 238.375C98.1532 237.17 98.0565 235.965 98 234.759C97.9241 233.134 99.5523 231.199 102.719 231.101C102.785 231.099 102.852 231.098 102.918 231.098ZM94.8921 250.215C94.8921 249.81 94.5745 249.491 94.1713 249.491C93.7681 249.491 93.4505 249.81 93.4505 250.215C93.4505 250.62 93.7681 250.939 94.1713 250.939C94.5745 250.939 94.8921 250.62 94.8921 250.215Z"
      fill="#4F2B1B"
    />
    <path
      v-if="pickedSkin === 'cowboy'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M122.149 231C122.19 231 122.231 231 122.272 231C122.344 231.001 122.417 231.003 122.491 231.006L122.495 231.006L122.513 231.007L123.666 231.093C124.982 231.246 126.075 231.581 126.906 232.227C127.952 233.041 128.677 234.378 128.923 236.762L129.095 238.423L129.975 237.006C130.302 236.479 130.905 236.168 131.5 235.986C131.156 237.557 130.795 239.124 130.417 240.687L130.119 241.902C129.462 244.552 132.04 247.211 131.298 249.745L131.21 250.045L134.693 254.086L135.675 254.84C138.579 255.251 142.463 255.989 145 259.344C142.947 259.66 139.934 259.632 136.845 259.602C135.377 259.588 133.891 259.574 132.484 259.597L131.185 258.899C129.999 258.026 128.794 257.299 127.549 256.882L126.358 257.801C125.908 258.492 125.626 259.23 125.461 259.944C124.677 260.002 123.805 260.043 123.108 259.919C122.195 259.051 121.584 258.207 121.243 257.284L121.154 256.124C121.228 255.862 121.303 255.572 121.383 255.266C121.703 254.042 122.091 252.559 122.699 251.566L122.693 251.545L122.693 251.569C121.55 251.379 120.714 251.183 119.63 250.834L119.62 250.859L119.617 250.866L120.414 252.468L118.819 251.667L118.792 251.679L118.771 251.688L118.735 251.703L118.171 253.401L117.608 251.703C117.579 251.692 117.551 251.68 117.523 251.667L115.929 252.468L116.726 250.866C116.72 250.852 116.714 250.838 116.708 250.824C116.702 250.809 116.696 250.795 116.69 250.781L115 250.214L116.69 249.649C116.702 249.62 116.713 249.591 116.726 249.563L115.929 247.961L117.523 248.762C117.539 248.755 117.556 248.748 117.572 248.741L117.608 248.727L118.171 247.028L118.735 248.727C118.763 248.738 118.792 248.75 118.819 248.762L120.414 247.961L119.617 249.563L119.629 249.59L119.64 249.617L119.652 249.648L120.076 249.78C120.308 249.84 120.536 249.903 120.762 249.965C121.459 250.157 122.136 250.344 122.869 250.43L122.867 250.445L122.877 250.427C122.108 246.745 118.095 243.084 117.645 239.423L117.513 238.277C117.385 237.072 117.288 235.867 117.231 234.661C117.155 233.036 118.784 231.101 121.95 231.003C122.017 231.001 122.083 231 122.149 231ZM118.892 250.215C118.892 249.81 118.574 249.49 118.171 249.49C117.768 249.49 117.451 249.81 117.451 250.215C117.451 250.62 117.768 250.939 118.171 250.939C118.574 250.939 118.892 250.62 118.892 250.215Z"
      fill="#4F2B1B"
    />
    <rect
      v-if="pickedSkin === 'wizard'"
      x="228.945"
      y="131.402"
      width="6"
      height="68"
      transform="rotate(60 228.945 131.402)"
      fill="#4F2B1B"
    />
    <rect
      v-if="pickedSkin === 'wizard'"
      x="228.213"
      y="134.134"
      width="2"
      height="31"
      transform="rotate(60 228.213 134.134)"
      fill="#C55805"
    />
    <path
      v-if="pickedSkin === 'wizard'"
      d="M174.824 85.6301C206.379 79.8531 231.154 70.7803 230.161 65.3605C229.515 61.8314 219.525 60.4643 202.923 61.7169L174.778 21.1011C172.269 17.4804 168.295 15.1456 163.911 14.7161L134.746 11.8594L141.705 19.9802C144.448 23.1812 145.717 27.3886 145.202 31.5725L140.076 73.2229C124.107 77.9334 115.248 82.7488 115.895 86.2803C116.887 91.7002 143.269 91.4071 174.824 85.6301Z"
      fill="#307AA1"
    />
    <rect
      v-if="pickedSkin === 'wizard'"
      x="145.752"
      y="39"
      width="4"
      height="39"
      rx="2"
      transform="rotate(6.9995 145.752 39)"
      fill="#1B516E"
    />
    <path
      v-if="pickedSkin === 'wizard'"
      d="M143 76.5C167.764 76.5355 181.358 74.5668 202.5 65.5"
      stroke="#1B516E"
      stroke-width="3"
      stroke-linecap="round"
    />
    <path
      v-if="pickedSkin === 'wizard'"
      d="M164 37L165.572 41.8369H170.658L166.543 44.8262L168.115 49.6631L164 46.6738L159.886 49.6631L161.457 44.8262L157.343 41.8369H162.429L164 37Z"
      fill="white"
    />
    <path
      v-if="pickedSkin === 'wizard'"
      d="M156 58L157.572 62.8369H162.658L158.543 65.8262L160.115 70.6631L156 67.6738L151.886 70.6631L153.457 65.8262L149.343 62.8369H154.429L156 58Z"
      fill="white"
    />
    <path
      v-if="pickedSkin === 'wizard'"
      d="M188 50L189.572 54.8369H194.658L190.543 57.8262L192.115 62.6631L188 59.6738L183.886 62.6631L185.457 57.8262L181.343 54.8369H186.429L188 50Z"
      fill="white"
    />
    <path
      v-if="pickedSkin === 'warrior'"
      d="M150.576 74.2063C139.32 71.1903 127.281 89.8487 126.156 97.8066C122.197 91.1981 119.608 83.8613 118.543 76.2329C117.478 68.6044 117.96 60.8402 119.959 53.4024C127.716 24.4513 156.309 6.59327 185.501 11.4191C188.083 11.8456 189.372 12.0582 190.07 13.1436C192.201 16.4456 187.615 26.0202 186.709 29.4007C192.082 26.8856 201.398 19.8505 207.626 20.5846C209.273 20.7849 210.376 21.6653 212.584 23.4204C220.398 29.6553 226.477 37.7947 230.234 47.0557C230.234 47.0557 209.733 44.7758 203.234 57.7746"
      fill="#9A2E34"
    />
    <path
      v-if="pickedSkin === 'warrior'"
      d="M214.502 75.5963C215.567 56.2335 204.554 43.2263 183.468 39.4053C153.913 34.0497 134.85 63.7087 142.217 91.5948C143.21 95.3512 140.913 99.6665 139.329 102.982C134.157 113.857 131.571 119.295 132.732 120.883C133.889 122.484 139.188 121.941 149.8 120.852C159.343 119.871 173.443 115.437 182.904 118.241C188.766 119.979 202.399 137.917 208.198 135.162C210.16 134.231 210.089 131.108 209.957 124.869L209.652 110.718C209.55 106.152 208.448 105.414 204.19 103.698C198.109 101.204 177.908 115.091 168.286 104.748C166.114 98.0475 166.977 92.8055 169.067 91.2811C172 82.5 203.522 93.0989 208.198 93.5C213.555 93.9588 214.198 81.0863 214.502 75.5963Z"
      fill="#210E01"
    />
    <path
      v-if="pickedSkin === 'postman'"
      d="M144.718 80.2865L147.24 87.4328C158.731 86.3021 166.163 83.9223 180.029 78.605C194.923 81.6842 203.15 82.6516 211.557 81.1272C227.89 78.1657 234.695 76.4579 233.837 73.1402C233.155 71.2983 232.333 70.8084 229.633 71.4587C222.532 67.7863 218.266 65.5568 208.194 60.1086L205.672 52.5419C203.657 45.1685 203.57 37.8289 203.991 31.9437C205.074 28.8045 205.621 27.0548 206.513 23.9566C206.933 21.8548 204.765 20.1733 202.309 21.4344C186.755 29.4215 155.648 48.7586 132.527 69.7772C130.846 71.4587 130.337 74.5285 132.107 78.1846C133.368 80.79 137.519 82.156 144.718 80.2865Z"
      fill="#22548C"
    />
    <path
      v-if="pickedSkin === 'postman'"
      d="M205.672 52.542C184.18 65.0964 171.134 71.7451 144.718 80.2865L147.241 87.4329C158.848 86.2345 166.095 84.175 180.03 78.6051C196.458 72.9192 202.165 68.561 210.717 61.3698L208.195 60.1087L205.672 52.542Z"
      fill="#4696EF"
    />
    <path
      v-if="pickedSkin === 'postman'"
      d="M206.093 22.2749C179.998 45.186 163.795 56.3156 131.687 72.7196C130.907 72.1449 131.267 71.0381 132.107 70.1974C155.648 48.7584 175.406 36.988 198.946 23.1157C203.21 20.7529 204.874 20.432 206.093 22.2749Z"
      fill="#4696EF"
    />
    <circle
      v-if="pickedSkin === 'postman'"
      cx="3.36298"
      cy="3.36298"
      r="3.36298"
      transform="matrix(-1 0 0 1 182.131 69.3569)"
      fill="#F2B76F"
    />
    <path
      v-if="pickedSkin === 'postman'"
      d="M206.513 56.3252C197.257 62.2112 191.792 65.3911 180.03 70.1975L180.871 74.4012C192.068 69.405 198.05 66.2849 207.774 59.6882L206.513 56.3252Z"
      fill="#F2B76F"
    />
    <path
      v-if="pickedSkin === 'postman'"
      d="M227.111 72.7197C216.302 77.6326 209.636 78.6919 193.482 77.3438"
      stroke="#F2B76F"
      stroke-width="3"
      stroke-linecap="round"
    />
    <g 
      v-if="pickedSkin === 'cook'"
      filter="url(#filter0_d_123_267)"
    >
      <path
        v-if="pickedSkin === 'cook'"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M205 79.5L203.193 63.5922C258.787 65.8434 260.588 21.2356 206.503 31.3139C207.005 7.07055 147.85 -2.79996 153.087 29.6169C115.591 -0.825857 70.89 47.3838 140.519 58.5011L148.437 86L205 79.5Z"
        fill="white"
      />
    </g>
    <path
      v-if="pickedSkin === 'cook'"
      d="M155.314 58.125C155.141 56.7552 156.111 55.5042 157.48 55.3309C158.85 55.1576 160.101 56.1275 160.274 57.4973L162.785 77.3391C162.958 78.7089 161.988 79.9598 160.619 80.1332C159.249 80.3065 157.998 79.3366 157.825 77.9668L155.314 58.125Z"
      fill="#BFBFBF"
    />
    <path
      v-if="pickedSkin === 'cook'"
      d="M171.187 56.1165C171.014 54.7467 171.984 53.4958 173.354 53.3225C174.724 53.1491 175.975 54.1191 176.148 55.4889L178.658 75.3307C178.832 76.7004 177.862 77.9514 176.492 78.1247C175.122 78.298 173.871 77.3281 173.698 75.9583L171.187 56.1165Z"
      fill="#BFBFBF"
    />
    <path
      v-if="pickedSkin === 'cook'"
      d="M187.061 54.108C186.888 52.7382 187.857 51.4873 189.227 51.314C190.597 51.1407 191.848 52.1106 192.021 53.4804L194.532 73.3222C194.705 74.692 193.735 75.9429 192.365 76.1162C190.996 76.2896 189.745 75.3196 189.571 73.9498L187.061 54.108Z"
      fill="#BFBFBF"
    />
    <path
      v-if="pickedSkin === 'fitness'"
      d="M176.705 198.187C176.682 198.739 176.216 199.167 175.665 199.144L172.497 199.012C171.945 198.989 171.517 198.523 171.54 197.971L171.672 194.803C171.695 194.252 171.266 193.786 170.715 193.763L162.381 193.414C161.829 193.391 161.401 192.925 161.424 192.373L161.556 189.206C161.579 188.654 161.15 188.188 160.599 188.165L157.431 188.033C156.879 188.01 156.45 187.544 156.474 186.992L156.714 181.241C156.737 180.689 157.203 180.261 157.755 180.284L172.253 180.89L173.764 144.728L159.265 144.123C158.714 144.099 158.285 143.633 158.308 143.082L158.548 137.331C158.571 136.779 159.037 136.351 159.589 136.374L162.757 136.506C163.309 136.529 163.775 136.1 163.798 135.549L163.93 132.381C163.953 131.829 164.419 131.401 164.971 131.424L173.304 131.772C173.856 131.795 174.322 131.366 174.345 130.814L174.478 127.647C174.501 127.095 174.967 126.666 175.518 126.689L178.686 126.822C179.238 126.845 179.667 127.311 179.643 127.863L179.511 131.03C179.488 131.582 179.917 132.048 180.469 132.071L188.802 132.419C189.354 132.442 189.782 132.908 189.759 133.46L189.627 136.628C189.604 137.18 190.033 137.646 190.584 137.669L193.752 137.801C194.304 137.824 194.733 138.29 194.71 138.842L194.469 144.592C194.446 145.144 193.98 145.573 193.428 145.55L178.93 144.944L177.419 181.105L191.918 181.711C192.469 181.734 192.898 182.2 192.875 182.752L192.635 188.503C192.612 189.054 192.146 189.483 191.594 189.46L188.426 189.328C187.875 189.305 187.408 189.733 187.385 190.285L187.253 193.453C187.23 194.004 186.764 194.433 186.212 194.41L177.879 194.062C177.327 194.039 176.861 194.467 176.838 195.019L176.705 198.187Z"
      fill="#323232"
    />
    <path
      v-if="pickedSkin === 'fitness'"
      d="M160.5 100C159.307 100 158.162 99.5094 157.318 98.6361C156.474 97.7628 156 96.5783 156 95.3433C156 92.2388 160.5 87 160.5 87C160.5 87 165 92.2388 165 95.3433C165 96.5783 164.526 97.7628 163.682 98.6361C162.838 99.5094 161.693 100 160.5 100Z"
      fill="#6ABDE1"
    />
    <path
      v-if="pickedSkin === 'fitness'"
      d="M195.5 81C194.572 81 193.682 80.6226 193.025 79.9508C192.369 79.2791 192 78.3679 192 77.4179C192 75.0299 195.5 71 195.5 71C195.5 71 199 75.0299 199 77.4179C199 78.3679 198.631 79.2791 197.975 79.9508C197.318 80.6226 196.428 81 195.5 81Z"
      fill="#6ABDE1"
    />
    <path
      v-if="pickedSkin === 'fitness'"
      d="M201.5 105C200.572 105 199.682 104.623 199.025 103.951C198.369 103.279 198 102.368 198 101.418C198 99.0299 201.5 95 201.5 95C201.5 95 205 99.0299 205 101.418C205 102.368 204.631 103.279 203.975 103.951C203.318 104.623 202.428 105 201.5 105Z"
      fill="#6ABDE1"
    />
    <path
      v-if="pickedSkin === 'firefighter'"
      d="M207.405 70.6119L195.608 38.8232C189.116 31.0272 181.205 31.3267 162.965 36.3741C146.059 41.0524 138.603 55.1799 140.646 79.2132L140.412 79.2433C124.873 85.1186 116.974 95.1574 117.61 98.714C117.214 100.481 120.547 99.7183 130.869 97.3548C141.881 94.8336 160.847 90.4912 191.725 85.4569C211.953 82.855 220.582 81.1511 220.23 76.6878C219.93 73.4047 216.459 72.2357 209.041 70.4011L207.405 70.6119Z"
      fill="#DE492F"
    />
    <path
      v-if="pickedSkin === 'firefighter'"
      d="M197.359 31.4047C201.135 30.4763 206.172 55.5221 209.189 72.3862C209.6 74.6819 204.538 72.864 201.59 64.9839L194.138 42.5185C193.547 41.2044 196.024 31.8813 197.359 31.4047Z"
      fill="#9A2E34"
    />
    <path
      v-if="pickedSkin === 'firefighter'"
      d="M173.002 84.5435C194.184 82.2541 200.636 79.9442 205.555 74.5767C197.472 79.4945 190.859 81.5448 172.735 83.052C145.887 85.2929 145.431 84.24 140.638 82.9917C143.169 85.7805 145.009 87.2535 173.002 84.5435Z"
      fill="#EE8977"
    />
    <path
      d="M190.425 162.937C190.425 162.937 181.36 159.098 169.904 153.525C158.447 147.951 142.422 127.195 121.518 128.46C100.614 129.724 92.5061 144.836 92.1234 155.513C91.7408 166.189 100.472 180.377 117.715 183.21C150.243 188.554 190.425 162.937 190.425 162.937Z"
      fill="#FFC82B"
    />
    <defs>
      <filter
        id="filter0_d_123_267"
        x="96"
        y="0"
        width="158"
        height="93"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_123_267"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_123_267"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>